import {
  getNepalPhoneValidationMessage,
  sanitizeNepalPhoneNumber
} from '@repo/auth/nepal-phone';

import type {
  DeletionIdentity,
  DeletionIdentityErrors
} from './account-deletion.types';

export function normalizeDeletionIdentity(
  identity: DeletionIdentity
): DeletionIdentity {
  return {
    ...identity,
    name: identity.name.trim(),
    email: identity.email.trim(),
    phone: sanitizeNepalPhoneNumber(identity.phone)
  };
}

export function validateDeletionIdentity(identity: DeletionIdentity) {
  const errors: DeletionIdentityErrors = {};
  if (!identity.name) errors.name = 'Full name is required.';
  if (!identity.email) errors.email = 'Email address is required.';
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/u.test(identity.email)) {
    errors.email = 'Enter a valid email address.';
  }
  const phoneError = getNepalPhoneValidationMessage(identity.phone);
  if (phoneError) errors.phone = phoneError;
  return errors;
}

export const remainingSeconds = (deadline: number, now: number) =>
  Math.max(0, Math.ceil((deadline - now) / 1000));

export const formatCodeTime = (seconds: number) =>
  `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
